import PropTypes from "prop-types";
import { Card, CardBody, Table } from "reactstrap";

function safeText(value, fallback = "(Non Renseigné)") {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  return text.length ? text : fallback;
}

const ProfileInfoSection = ({ title, items, emptyFallback, className }) => (
  <Card className={className}>
    <CardBody>
      <h5 className="card-title mb-3">{title}</h5>
      <div className="table-responsive">
        <Table className="table-borderless mb-0">
          <tbody>
            {items.map((item) => (
              <tr key={item.label}>
                <th className="ps-0" scope="row">
                  {item.label}
                </th>
                <td className="text-muted">{safeText(item.value, emptyFallback)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </CardBody>
  </Card>
);

ProfileInfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ),
  emptyFallback: PropTypes.string,
  className: PropTypes.string,
};

ProfileInfoSection.defaultProps = {
  items: [],
  emptyFallback: "(Non Renseigné)",
  className: "",
};

export default ProfileInfoSection;
